







import { getAppTenant, TENANT } from '@/environment-detection'

export const isSennderTheme =
  getAppTenant() === TENANT.SENNDER || getAppTenant() === undefined
export const isPosteTheme = getAppTenant() === TENANT.POSTE

export default {
  computed: {
    isSennderTheme() {
      return isSennderTheme
    },
    isPosteTheme() {
      return isPosteTheme
    }
  }
}
